// Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved

import {css} from 'emotion';
import React, {useState} from 'react';
import { useDispatch } from 'react-redux'
import {  addTodo } from '../actions';


export default function TodoInput() {
  
  const [newTodo, setNewTodo] = useState('');
  const dispatch = useDispatch();

  return (
    <input
      className={styles.root}
      type="text"
      onChange={e => setNewTodo(e.target.value)}
      onKeyDown={e => {
        if (e.key === 'Enter') {
          dispatch(addTodo(newTodo));
          setNewTodo('');
        }
      }}
      placeholder="What needs to be done?"
      value={newTodo}
    />
  );
}

const styles = {
  root: css`
    box-sizing: border-box;
    font-size: 16px;
    margin-bottom: 24px;
    padding: 8px 12px;
    width: 100%;
  `,
};
